import PriceList from 'components/common/helpers/PriceList';

class BookingReducerHelper {
  constructor(state) {
    this.state = state;
    this.priceList = null;
    return this;
  }

  setPriceList(priceList) {
    this.priceList = priceList;
    return this;
  }

  phoneHasChanged(newState) {
    return this.state.userData.phone !== newState.userData.phone ||
      this.state.userData.phoneCountry.label !== newState.userData.phoneCountry.label;
  }

  getDeparturePrice() {
    if (this.state.departureFlight === null || this.state.departureFlight.airport === null) {
      return null;
    }

    var airportCode = this.state.departureFlight.airport.code;
    return this.getPriceForAddressObject(this.state.departureAddress, airportCode);
  }

  getReturnPrice() {
    if (this.state.returnFlight === null || this.state.returnFlight.airport === null) {
      return 0;
    }

    var address;
    if (this.state.differentReturnAddress) {
      address = this.state.returnAddress;
    } else {
      address = this.state.departureAddress;
    }
    var airportCode = this.state.returnFlight.airport.code;
    return this.getPriceForAddressObject(address, airportCode);
  }

  getPriceForAddressObject(addressObject, airportCode) {
    var selectedObject = addressObject.selectedObject;
    if (!selectedObject) {
      return 0;
    }

    if (selectedObject.g) {
      var busStopName = null;
      var postcode = addressObject.postcode;
    } else {
      var busStopName = selectedObject.value;
      var postcode = null;
    }
    var adults = this.state.adultsNumber;
    var children = this.state.childrenNumber;
    var students = this.state.studentsNumber;
    var stateParams = {
      busStopName,
      postcode,
      adults,
      children,
      students
    };
    var priceParams = _.merge({}, stateParams);
    return new PriceList(this.priceList, airportCode).getTotalPrice(priceParams);
  }
}

export default BookingReducerHelper;
